module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_24.36be89a7.png";